import getUrlParameter from './getUrlParameter';

const IS_PROD = process.env.REACT_APP_MODE === 'PRODUCTION';
const SLUG_PATTERN = /^[a-z0-9._-]+$/;

/**
 * `?retailer=<slug>` lets local and staging builds pick a store, since their
 * hostname does not map to one. Production must resolve the tenant from the
 * hostname only, otherwise a link on retailer A's domain could load retailer
 * B's config and send logins to B. Returns '' in production or for anything
 * that is not a plain slug.
 *
 * @param {string} [search=window.location.search]
 * @returns {string}
 */
export default function getRetailerOverride(search = window.location.search) {
  if (IS_PROD) return '';

  const retailer = getUrlParameter(search || '', 'retailer').toLowerCase();
  return SLUG_PATTERN.test(retailer) ? retailer : '';
}
